/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UpdateCustomFieldDropdownOptionsInput = {
    customFieldDefinitionId: string;
    options: Array<CustomFieldDropdownOptionInputType>;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type CustomFieldDropdownOptionInputType = {
    id?: string | null | undefined;
    displayName: string;
};
export type UpdateCustomFieldDropdownOptionsMutationVariables = {
    input: UpdateCustomFieldDropdownOptionsInput;
};
export type UpdateCustomFieldDropdownOptionsMutationResponse = {
    readonly updateCustomFieldDropdownOptions: {
        readonly options: ReadonlyArray<{
            readonly id: string;
            readonly displayName: string;
        } | null> | null;
    } | null;
};
export type UpdateCustomFieldDropdownOptionsMutation = {
    readonly response: UpdateCustomFieldDropdownOptionsMutationResponse;
    readonly variables: UpdateCustomFieldDropdownOptionsMutationVariables;
};



/*
mutation UpdateCustomFieldDropdownOptionsMutation(
  $input: UpdateCustomFieldDropdownOptionsInput!
) {
  updateCustomFieldDropdownOptions(input: $input) {
    options {
      id
      displayName
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCustomFieldDropdownOptionsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldDropdownOptionsPayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldDropdownOptions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldDropdownOption",
        "kind": "LinkedField",
        "name": "options",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "displayName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateCustomFieldDropdownOptionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateCustomFieldDropdownOptionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateCustomFieldDropdownOptionsMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateCustomFieldDropdownOptionsMutation(\n  $input: UpdateCustomFieldDropdownOptionsInput!\n) {\n  updateCustomFieldDropdownOptions(input: $input) {\n    options {\n      id\n      displayName\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '59aa367654fab3292a47fcbad3d0c40b';
export default node;
